import {defineStore} from "pinia";
import {useAuthStore} from "@/stores/authStores";
import api from "@/services/api";


export const useAlarmsStore = defineStore('alarms', {
    state: () => ({
        alarmsHistory: [],
        selected: [],
        defaultPopupConfig: {
            "Tc1-TrainIntegrityLost": true,
            "Tc2-TrainIntegrityLost": true,
            "Tc2-Panel4Activated": true
        },

        popupConfig : {
            "Tc1-TrainIntegrityLost": true,
            "Tc2-TrainIntegrityLost": true,
            "Tc2-Panel4Activated": true
        },

        lostAlarm: false,
        alarmHistoryActive: false
    }),

    getters: {
        getHistory: state => {
            // Sort the alarms by timestamp in descending order
            return state.alarmsHistory.sort((a, b) => {
                return new Date(b.timestamp) - new Date(a.timestamp);
            });
        }

    },

    actions: {
        acknowledge(id) {
            api.put(
                '/alarms/acknowledge',
                {},
                {
                    headers: {'Content-Type': 'application/json'},
                    params: {
                        id: id,
                        ackBy: useAuthStore().loggedUser,
                        ackTime: Date.now(),
                    }
                }
            )
                .then(response => {
                    console.log(response);
                    this.fetchHistory();
                })
                .catch(error => {
                    console.error("There was an error acknowledging the alarm:", error);
                });
        },

        fetchHistory() {
            api.get('/alarms/getHistory')
                .then(response => {
                    this.alarmsHistory = response.data;
                })
                .catch(error => {
                    console.error("There was an error fetching the call history:", error);
                });
        },

        resetPopupConfig() {
            this.popupConfig = this.defaultPopupConfig;
        }
    }
})